/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListMarketMakersOptions, ListMarketMakersResponses } from '../types/ListMarketMakers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. All percentages are fractions in [0,1]. Ordered by created_at descending, then ID. An empty page returns [].
 * @summary List market makers
 * {@link /v1/market-makers}
 */
export function listMarketMakers<ThrowOnError extends boolean = true>(
  options: Options<ListMarketMakersOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListMarketMakersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListMarketMakersResponses, ThrowOnError>>,
  )
}
